import { Box, Typography } from '@mui/material'
import React from 'react'
import { useSize } from '../../../hooks/useSize'
import styles from '../common.module.scss'

const Compliance: React.FC = () => {
  const { matchTabletSize } = useSize()

  return (
    <>
      <Box maxWidth="md" className={`${styles.header} ${matchTabletSize ? styles.header__sp : styles.header__pc}`}>
        <Typography lineHeight={0.9} fontSize={matchTabletSize ? '26px' : '43px'} fontWeight="bold">
          コンプライアンス
        </Typography>
        <Typography fontSize={matchTabletSize ? '12px' : '20px'}>Compliance</Typography>
      </Box>
      <Box maxWidth="md" m="auto">
        <article className={matchTabletSize ? styles.container__sp : styles.container__pc}>
          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              通報窓口（ホットライン）
            </Typography>
            <Typography variant="body1">
              当社では、法令違反、ハラスメントその他コンプライアンス上の問題の早期発見および是正を目的として、
              通報窓口（ホットライン）を設置しています。
            </Typography>
            <Typography variant="body1">
              本窓口は、当社の役員および社員のほか、退職後1年以内の元社員、ならびに当社の業務に従事する
              役務提供者（当社と取引関係にある企業・団体に所属し当社業務に従事する方、
              業務委託契約に基づき当社業務に従事する方等）が利用できます。
            </Typography>
            <Typography variant="body1">
              通報の受付および対応にあたっては、公益通報者保護法その他関係法令の趣旨に則り、通報者の秘密を保持し、
              不利益な取扱いを行わないことを徹底するとともに、適切な調査および是正措置を実施します。
            </Typography>
          </Box>
        </article>
      </Box>
    </>
  )
}

export default Compliance
